import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

export const Container = styled.div`
  inline-size: 100%;
  max-inline-size: 390px;
  margin-block-end: 19px;
  margin-inline-start: -10px;
`;

type LetterProps = {
  $isActive: boolean;
};
export const Letter = styled.span<LetterProps>`
  display: inline-block;

  padding-block: 0;
  padding-inline: 10px;

  color: ${props => (props.$isActive ? "#000" : "#4585ff")};
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 32px;
  text-align: center;
  text-transform: uppercase;

  cursor: pointer;

  &:hover {
    background-color: #f7f7f7;
  }
`;
